import React, { useCallback, useContext, useState } from 'react';
import {
  INavigationContext,
  INavigationContextStateProps
} from './NavigationContextProvider.types';

const initialContext: INavigationContext = {
  hasNavigatedSubEntityId: false,
  currentViewIsDeepLink: false
};

export const NavigationContext = React.createContext<
  INavigationContextStateProps
>({
  navigationContext: initialContext,
  setNavigationContext: (_context: INavigationContext) => {
    return;
  }
});

export const NavigationContextProvider: React.FC = props => {
  const [navigationContext, setNavigationContextDispatch] = useState<
    INavigationContext
  >(initialContext);

  const setNavigationContext = useCallback(
    (context: INavigationContext) => {
      setNavigationContextDispatch({
        ...navigationContext,
        ...context
      });
    },
    [navigationContext]
  );

  return (
    <NavigationContext.Provider
      value={{
        navigationContext,
        setNavigationContext
      }}
    >
      {props.children}
    </NavigationContext.Provider>
  );
};

export const useNavigationContext = () => useContext(NavigationContext);
